<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useClaimStore, useNotificationStore } from '@/store';
import adminAPI from '../../services/api';
import DotLegalStep from '../ui/badges/DotLegalStep.vue';
import BaseButton from '../ui/buttons/BaseButton.vue';
import { RetrieveClaimWithRelationsResponse } from '@upclaim/sdk/src/data-contracts';
import GenerateFormalNotice from '../overview/GenerateFormalNotice.vue';
import ClaimDocuments from '../overview/ClaimDocuments.vue';
import Alert from '../ui/alerts/Alert.vue';
import { claimEventTypesByType } from '@/utils/config/constants';

const props = defineProps<{
  claim: RetrieveClaimWithRelationsResponse;
}>();

// const claimId = ref(props.claim?.id);
const formalNotice = ref();
const isLoading = ref(true);

const event = claimEventTypesByType("UPCLAIM.MED_SENT");
async function addEvent() {
  await adminAPI.addEvent(props.claim.id, { machineEvent: event.machine_source_id });
  await useClaimStore().refreshClaim();
}

watch(() => props.claim, async (claim) => {
  if (claim) {
    isLoading.value = true;
    formalNotice.value = await adminAPI.retrieveClaimFormalNotice(claim.id);
    isLoading.value = false;
  }
}, { immediate: true });
</script>
<template>
<div class="border-b bg-slate-50">
  <div class="max-w-lg py-5 mx-auto text-left">
    <div class="p-8 bg-white border rounded-md shadow">
      <h2 class="inline-flex text-base font-semibold leading-6 text-gray-900 align-middle">
        <div class="py-1 mr-2"><DotLegalStep :legal-step-name="useClaimStore().claim.claimLegalStep.name" /></div>
        Actions requises
      </h2>
      <p class="mt-4 text-sm leading-6 text-gray-500">
        <span class="font-semibold leading-8 text-gray-900">Préparer et envoyer la Mise en Demeure<br></span>
        Bien vérifier les montants et Fiche entreprise (adresse postale de la compagnie, RCS, etc).
      </p>


      <div class="py-6" v-if="!isLoading">
        <div v-if="!formalNotice?.formalNoticePdfFileId"  class="relative block py-4 text-sm">
          <div>
            <GenerateFormalNotice :claim="claim" :formal-notice="formalNotice" />
            <ClaimDocuments :claim="claim" />
          </div>
        </div>
        <div v-else>
          <Alert type="success" title="Mise en Demeure détectée" message="Il faut maintenant l'envoyer à l'adresse de la compagnie." :with-border="false">
            <div class="mt-4">
              <BaseButton text="J'ai posté la MED" @click="addEvent" />
            </div>
          </Alert>
        </div>
      </div>
    </div>
  </div>
</div>
</template>